var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Toolbar" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("ItemSrcControl", {
          attrs: { filenameWithCoordinates: _vm.filenameWithCoordinates }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "Toolbar_HighlightControllers" },
      [
        _c("ItemOrderControl", {
          attrs: { selectedItemLabel: _vm.selectedItemLabel },
          on: { changeSelectedItemLabel: _vm.onChangeSelectedItemLabel }
        }),
        _vm._v(" "),
        _c("ItemCoordinateControl", {
          attrs: {
            coordinateKey: "x",
            editScreen: _vm.editScreen,
            coordinates: _vm.coordinates
          }
        }),
        _vm._v(" "),
        _c("ItemCoordinateControl", {
          attrs: {
            coordinateKey: "y",
            editScreen: _vm.editScreen,
            coordinates: _vm.coordinates
          }
        }),
        _vm._v(" "),
        _c("ItemCoordinateControl", {
          attrs: {
            coordinateKey: "w",
            editScreen: _vm.editScreen,
            coordinates: _vm.coordinates
          }
        }),
        _vm._v(" "),
        _c("ItemCoordinateControl", {
          attrs: {
            coordinateKey: "h",
            editScreen: _vm.editScreen,
            coordinates: _vm.coordinates
          }
        }),
        _vm._v(" "),
        _c("ItemZoomControl", { on: { zoom: _vm.onZoom } }),
        _vm._v(" "),
        _c("div", [
          _c("button", { on: { click: _vm.onRemoveScreenMetadata } }, [
            _vm._v("Delete Image")
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", { staticClass: "Toolbar_Label" }, [
        _vm._v("\n      src\n    ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", { staticClass: "Toolbar_Label" }, [
        _vm._v("\n      label\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }